import { loadSite } from "./api";

export async function initAbout(): Promise<void> {
  const site = await loadSite();
  const bio = document.getElementById("bio");
  if (bio) bio.innerHTML = site.bio;
}
